import Pay from './Pay.js';
export default Pay;
//# sourceMappingURL=index.js.map